import React from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { GiTakeMyMoney } from "react-icons/gi";
import {
  AiFillBank,
  AiOutlineSchedule,
  AiOutlineInsurance,
  AiOutlineDownload,
} from "react-icons/ai";
import { IoNotifications } from "react-icons/io5";
import { BiTransferAlt, BiSupport } from "react-icons/bi";
import { CgProfile, CgMenuLeft } from "react-icons/cg";
import logo from "../../../images/logo1.png";
import { darkThemeColor } from "../styles";

import { logout } from "../../../redux/reducers/user";
import { removeState } from "../../../utils/useLocalStorage";

function Sidebar() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.value);

  return (
    <Container>
      <ProfileContainer>
        <Avatar src={logo} />
      </ProfileContainer>
      <LinksContainer>
        <Links>
          <MenuLink>
            <CgMenuLeft />
            <h3>MENU</h3>
          </MenuLink>
          <Link>
            <AiFillBank />
            <h3>KYC</h3>
          </Link>
          <Link>
            <BiTransferAlt />
            <h3>Transactions</h3>
          </Link>
          <Link>
            <CgProfile />
            <h3>Profile</h3>
          </Link>
          <Link>
            <AiOutlineSchedule />
            <h3>Schedule Payment</h3>
          </Link>
          <Link>
            <AiOutlineInsurance />
            <h3>Insurance Packages</h3>
          </Link>
          <Link>
            <GiTakeMyMoney />
            <h3>Take loan</h3>
          </Link>
          <Link>
            <AiOutlineDownload />
            <h3>Download statement</h3>
          </Link>
          <Link>
            <IoNotifications />
            <h3>Notifications</h3>
          </Link>
          <Link>
            <BiSupport />
            <h3>Support</h3>
          </Link>
        </Links>
        <Logout>
          <a
            href="/login"
            onClick={() => {
              dispatch(logout(user));
              removeState("user");
            }}
          >
            Log Out
          </a>
        </Logout>
      </LinksContainer>
    </Container>
  );
}

const Container = styled.div`
  width: 30vw;
  min-width: 200px;
  height: 100% !important;
  border-radius: 2rem;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3rem;
  margin: 1rem 0 1rem 1rem;
  @media screen and (min-width: 320px) and (max-width: 768px) {
    width: 100%;
    height: max-content !important;
  }
`;

const MenuLink = styled.li`
  margin-left: 30%;
  margin-bottom: 2rem;
  display: none;
  gap: 1rem;
  color: #0a0b69;
  cursor: pointer;
  h3 {
    font-weight: 300;
    font-size: 1rem;
  }
  svg {
    font-size: 1.1rem;
  }
  @media screen and (min-width: 320px) and (max-width: 768px) {
    display: flex;
  }
`;

const ProfileContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Avatar = styled.img`
  height: 5rem;
  width: 90%;
  margin-top: 5%;
`;

const LinksContainer = styled.div`
  background-color: ${darkThemeColor};
  height: 100%;
  width: 100%;
  border-radius: 2rem;
`;

const Links = styled.ul`
  list-style-type: none;
  display: flex;
  flex-direction: column;
  padding-top: 2rem;
  padding-left: 0;
  height: 60%;
`;

const Link = styled.li`
  margin-left: 15%;
  margin-bottom: 2rem;
  display: flex;
  gap: 1rem;
  color: #0a0b69;
  cursor: pointer;
  h3 {
    font-weight: 300;
    font-size: 1rem;
  }
  svg {
    font-size: 1.1rem;
  }
  @media screen and (min-width: 320px) and (max-width: 768px) {
    display: none;
  }
`;

const Logout = styled.div`
  width: 60%;
  background-color: #0a0b69;
  color: #c4c4c4;
  height: 10%;
  margin: 0 auto;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  margin-bottom: 2rem;

  a {
    color: white;
    text-decoration: none;
    text-align: center;
  }

  @media screen and (min-width: 320px) and (max-width: 1080px) {
    margin-bottom: 2rem;
  }
  @media screen and (min-width: 320px) and (max-width: 768px) {
    display: none;
  }
`;

export default Sidebar;
